import { values } from 'ramda';
import { FUNCTION_OR_QUERY } from '../constants';
export class SeparateStatesByType {
    constructor(states) {
        this.getFunctionAndQueryStates = () => values(this.states).filter(state => FUNCTION_OR_QUERY.includes(state.type));
        this.getNoQueryOrFunctionStates = () => values(this.states).filter(state => !FUNCTION_OR_QUERY.includes(state.type));
        this.states = states;
    }
}
